export enum AuthStep {
    ROLE_SELECTION = 'role-selection',
    ADMIN_LOGIN = 'admin-login',
    SUB_ADMIN_LOGIN = 'sub-admin-login'
}

export enum UserRole {
    ADMIN = 'admin',
    SUB_ADMIN = 'sub-admin'
}

export enum RoutePath {
    DASHBOARD = 'dashboard',
    USERS = 'users',
    SETTINGS = 'settings',
    LOGIN = 'login',
    SUB_ADMIN = 'sub-admin',
    FAQ = 'faq',
    BLOG = 'blog',
    CATEGORY = 'category',
    FAQ_CATEGORY = 'faq-category',
    BLOG_CATEGORY = 'blog-category',
    PARTNERS = 'partners',
    PARTNER_CATEGORY = 'partner-category',
    AUDIT_REPORT = 'audit-report',
    AUDIT_CATEGORY = 'audit-category',
    ANNOUNCEMENT = 'announcements',
    VOTE_DOMAIN = 'vote-domain'
}


export enum CategoryType {
    FAQ = 'faq',
    BLOG = 'blog',
    PARTNER = 'our-partner',
    AUDIT = 'audit-report'
}